
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { __assign } from '../../../../../../tslib/tslib.es6.mjs.js';
import { isSVGComponent } from './is-svg-component.mjs.js';
import { createUseRender } from '../use-render.mjs.js';
import { svgMotionConfig } from '../../svg/config-motion.mjs.js';
import { htmlMotionConfig } from '../../html/config-motion.mjs.js';

function createDomMotionConfig(Component, _a, preloadedFeatures, createVisualElement, projectionNodeConstructor) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = isSVGComponent(Component)
        ? svgMotionConfig
        : htmlMotionConfig;
    return __assign(__assign({}, baseConfig), { preloadedFeatures: preloadedFeatures, useRender: createUseRender(forwardMotionProps), createVisualElement: createVisualElement, projectionNodeConstructor: projectionNodeConstructor, Component: Component });
}

export { createDomMotionConfig };
//# sourceMappingURL=create-config.mjs.js.map
